import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '../../../../core/translation';

@Component({
  selector: 'sg-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss'],
})
export class ConfirmModalComponent {

  textAreaValue = '';
  disableTextArea = false;
  maxNumberOfCharacters = 255;
  minLenght = 10;
  disableDecline = true;

  _transParam = false;

  constructor(
    public dialogRef: MatDialogRef<ConfirmModalComponent>,
    public translate: TranslateService) {}

  closeModal(option: boolean) {
    this.dialogRef.close({option: option, value: this.textAreaValue});
  }

  updateTextAreaValue(text: string) {
    this.textAreaValue = text;
    this.disableDecline = this.textAreaValue.length < this.minLenght;
  }


}
